import { Breakpoint } from '@mui/material';

export type TwoColColumnsVariant = 'stretch-narrow' | 'wide-narrow' | 'narrow-wide' | 'half';
export type OneColColumnsVariant = 'full-wide' | 'wide' | 'middle' | 'narrow';
export type ColumnsVariant = OneColColumnsVariant | TwoColColumnsVariant;

export const wideScreenBreakpointMap: Record<TwoColColumnsVariant, Breakpoint> = {
  'stretch-narrow': 'lg',
  'wide-narrow': 'lg',
  'narrow-wide': 'lg',
  half: 'md',
};

export const singleColumnLayouts: OneColColumnsVariant[] = ['full-wide', 'wide', 'middle', 'narrow'];
export const doubleColumnLayouts: TwoColColumnsVariant[] = ['stretch-narrow', 'wide-narrow', 'narrow-wide', 'half'];

export const singleColumnMaxWidths: Record<OneColColumnsVariant, string | undefined> = {
  wide: '1024px',
  middle: '648px',
  narrow: '376px',
  'full-wide': undefined,
};

export const gap: Record<Breakpoint, number> = {
  xs: 2,
  sm: 2.5,
  md: 2.5,
  lg: 2.5,
  xl: 2.5,
};

export const yMargin: Record<Breakpoint, number> = {
  xs: 1,
  sm: 3,
  md: 4,
  lg: 4,
  xl: 4,
};

export const xMargin: Record<Breakpoint, number> = {
  xs: 1,
  sm: 3,
  md: 4,
  lg: 4,
  xl: 11,
};
